import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class ScrollAnimator {
  constructor() {
    this.initAnimator()
  }

  initAnimator() {
    gsap.registerPlugin(ScrollTrigger)
    gsap.utils.toArray('.gs-reveal:not([style])').forEach((block) => this.animateBlock(block))
    gsap.utils.toArray('.gs-lines:not([style]').forEach((block) => this.animateLines(block))
  }

  hide(block) {
    gsap.set(block, { autoAlpha: 0 })
  }

  animateFrom(block, direction = 1) {
    let x = 0
    let y = direction * 100
    if (block.classList.contains('gs-reveal--left')) {
      x = -100
      y = 0
    } else if (block.classList.contains('gs-reveal--right')) {
      x = 100
      y = 0
    }
    gsap.fromTo(block, { x, y, autoAlpha: 0 }, {
      duration: 1.25,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'expo',
      overwrite: 'auto',
      delay: 0.25
    })
  }

  animateBlock(block) {
    this.hide(block)
    ScrollTrigger.create({
      onEnter: () => this.animateFrom(block),
      once: true,
      trigger: block
    })
  }

  animateLines(block) {
    ScrollTrigger.create({
      toggleClass: 'testimonial-block__data--filled',
      once: true,
      trigger: block
    })
  }
}
